export default "__VITE_ASSET__57f24e5b__"